import cancelBooking from "../../../actions/siteadmin/cancelBooking/cancelBooking";

const submit = async (values, dispatch) => {
    dispatch(cancelBooking({
        bookingId: values?.bookingId,
        requestBy: values?.requestBy,
        currentPage: values?.currentPage,
        reason: values?.reason == 'other' ? values.otherReason : values.reason,
        status: values?.status
    }))
}

export default submit;